import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { Platform } from "react-native";
import { State } from "../../State";
import { DEFAULT_TOUCH_SLOP } from "../constants";
import GestureHandler from "./GestureHandler";
var NativeViewGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(NativeViewGestureHandler, GestureHandler);
    var _super = _create_super(NativeViewGestureHandler);
    function NativeViewGestureHandler() {
        _class_call_check(this, NativeViewGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "buttonRole", void 0);
        //TODO: Implement logic for activation on start
        //@ts-ignore Logic yet to be implemented
        _define_property(_assert_this_initialized(_this), "shouldActivateOnStart", false);
        _define_property(_assert_this_initialized(_this), "disallowInterruption", false);
        _define_property(_assert_this_initialized(_this), "startX", 0);
        _define_property(_assert_this_initialized(_this), "startY", 0);
        _define_property(_assert_this_initialized(_this), "minDistSq", DEFAULT_TOUCH_SLOP * DEFAULT_TOUCH_SLOP);
        return _this;
    }
    _create_class(NativeViewGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "init", this).call(this, ref, propsRef);
                this.setShouldCancelWhenOutside(true);
                if (Platform.OS !== "web") {
                    return;
                }
                var view = this.delegate.getView();
                view.style["touchAction"] = "auto";
                //@ts-ignore Turns on defualt touch behavior on Safari
                view.style["WebkitTouchCallout"] = "auto";
                if (view.hasAttribute("role")) {
                    this.buttonRole = true;
                } else {
                    this.buttonRole = false;
                }
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
                if (this.config.shouldActivateOnStart !== undefined) {
                    this.shouldActivateOnStart = this.config.shouldActivateOnStart;
                }
                if (this.config.disallowInterruption !== undefined) {
                    this.disallowInterruption = this.config.disallowInterruption;
                }
            }
        },
        {
            key: "resetConfig",
            value: function resetConfig() {
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "resetConfig", this).call(this);
            }
        },
        {
            key: "onPointerDown",
            value: function onPointerDown(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "onPointerDown", this).call(this, event);
                this.newPointerAction();
            }
        },
        {
            key: "onPointerAdd",
            value: function onPointerAdd(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "onPointerAdd", this).call(this, event);
                this.newPointerAction();
            }
        },
        {
            key: "newPointerAction",
            value: function newPointerAction() {
                this.startX = this.tracker.getLastAvgX();
                this.startY = this.tracker.getLastAvgY();
                if (this.currentState !== State.UNDETERMINED) {
                    return;
                }
                this.begin();
                if (this.buttonRole) {
                    this.activate();
                }
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                this.tracker.track(event);
                var dx = this.startX - this.tracker.getLastAvgX();
                var dy = this.startY - this.tracker.getLastAvgY();
                var distSq = dx * dx + dy * dy;
                if (distSq >= this.minDistSq) {
                    if (this.buttonRole && this.currentState === State.ACTIVE) {
                        this.cancel();
                    } else if (!this.buttonRole && this.currentState === State.BEGAN) {
                        this.activate();
                    }
                }
            }
        },
        {
            key: "onPointerLeave",
            value: function onPointerLeave() {
                if (this.currentState === State.BEGAN || this.currentState === State.ACTIVE) {
                    this.cancel();
                }
            }
        },
        {
            key: "onPointerUp",
            value: function onPointerUp(event) {
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "onPointerUp", this).call(this, event);
                this.onUp(event);
            }
        },
        {
            key: "onPointerRemove",
            value: function onPointerRemove(event) {
                _get(_get_prototype_of(NativeViewGestureHandler.prototype), "onPointerRemove", this).call(this, event);
                this.onUp(event);
            }
        },
        {
            key: "onUp",
            value: function onUp(event) {
                this.tracker.removeFromTracker(event.pointerId);
                if (this.tracker.getTrackedPointersCount() === 0) {
                    if (this.currentState === State.ACTIVE) {
                        this.end();
                    } else {
                        this.fail();
                    }
                }
            }
        },
        {
            key: "shouldRecognizeSimultaneously",
            value: function shouldRecognizeSimultaneously(handler) {
                if (_get(_get_prototype_of(NativeViewGestureHandler.prototype), "shouldRecognizeSimultaneously", this).call(this, handler)) {
                    return true;
                }
                if (_instanceof(handler, NativeViewGestureHandler) && handler.getState() === State.ACTIVE && handler.disallowsInterruption()) {
                    return false;
                }
                var canBeInterrupted = !this.disallowInterruption;
                if (this.currentState === State.ACTIVE && handler.getState() === State.ACTIVE && canBeInterrupted) {
                    return false;
                }
                return this.currentState === State.ACTIVE && canBeInterrupted && handler.getTag() > 0;
            }
        },
        {
            key: "shouldBeCancelledByOther",
            value: function shouldBeCancelledByOther(_handler) {
                return !this.disallowInterruption;
            }
        },
        {
            key: "disallowsInterruption",
            value: function disallowsInterruption() {
                return this.disallowInterruption;
            }
        }
    ]);
    return NativeViewGestureHandler;
}(GestureHandler);
export { NativeViewGestureHandler as default };
